export const FormatoMonedaMixin = {
  methods: {
    montoMoneda(monto) {
      const opcionesConversion = { style: 'currency', currency: 'MXN' }
      const montoFormatoMoneda = new Intl.NumberFormat(
        'es-MX',
        opcionesConversion
      )

      return montoFormatoMoneda.format(monto)
    },
  },
}
